window.sanitizeCnpj = function (value) {
    if (value === "" || value === null || value === undefined) {
        return "";
    }

    return String(value).toUpperCase().replace(/[^0-9A-Z]/g, "");
};

window.isValidCPF = function (cpf) {
    if (cpf === "") {
        return true;
    }
    if (cpf === null) {
        return false;
    }
    cpf = cpf.replace(/\D/g, "");
    // tslint:disable-next-line: one-variable-per-declaration
    let numeros, digitos, soma, i, resultado, digitosIguais;
    digitosIguais = 1;
    if (cpf.length < 11) {
        return false;
    }
    for (i = 0; i < cpf.length - 1; i++) {
        if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
            digitosIguais = 0;
            break;
        }
    }
    if (!digitosIguais) {
        numeros = cpf.substring(0, 9);
        digitos = cpf.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--) {
            soma += numeros.charAt(10 - i) * i;
        }

        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        // tslint:disable-next-line: triple-equals
        if (resultado != digitos.charAt(0)) {
            return false;
        }
        numeros = cpf.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i--) {
            soma += numeros.charAt(11 - i) * i;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        // tslint:disable-next-line: triple-equals
        if (resultado != digitos.charAt(1)) {
            return false;
        }
        return true;
    }
    return false;
};

window.cnpjCharValue = function (char) {
    return char.toUpperCase().charCodeAt(0) - 48;
};

window.isValidCNPJ = function (value) {
    if (value === "") {
        return true;
    }
    if (value === null) {
        return false;
    }

    const maskedPattern = /^[0-9A-DEGHJK-NP-R-STV-Z]{2}\.[0-9A-DEGHJK-NP-R-STV-Z]{3}\.[0-9A-DEGHJK-NP-R-STV-Z]{3}\/[0-9A-DEGHJK-NP-R-STV-Z]{4}-[0-9]{2}$/i;
    if (!maskedPattern.test(value)) {
        return false;
    }

    const cnpj = window.sanitizeCnpj(value);
    const basePattern = /^[0-9A-DEGHJK-NP-R-STV-Z]{12}[0-9]{2}$/i;

    if (cnpj.length !== 14 || !basePattern.test(cnpj)) {
        return false;
    }

    if (/[IOUQF]/i.test(cnpj.substring(0, 12))) {
        return false;
    }

    if (/(.)\1{13}/.test(cnpj)) {
        return false;
    }

    let soma = 0;
    for (let i = 0, j = 5; i < 12; i++) {
        soma += window.cnpjCharValue(cnpj[i]) * j;
        j = j === 2 ? 9 : j - 1;
    }

    let resto = soma % 11;
    const dv1 = resto < 2 ? 0 : 11 - resto;

    if (parseInt(cnpj[12], 10) !== dv1) {
        return false;
    }

    soma = 0;
    for (let i = 0, j = 6; i < 13; i++) {
        soma += window.cnpjCharValue(cnpj[i]) * j;
        j = j === 2 ? 9 : j - 1;
    }

    resto = soma % 11;

    return parseInt(cnpj[13], 10) === (resto < 2 ? 0 : 11 - resto);
};

window.cleanCnpjInput = function (value) {
    let raw = window.sanitizeCnpj(value);
    let clean = "";

    for (let i = 0; i < raw.length && clean.length < 14; i++) {
        const ch = raw[i];
        if (/[IOUQF]/.test(ch)) {
            continue;
        }
        if (clean.length >= 12 && !/[0-9]/.test(ch)) {
            continue;
        }
        clean += ch;
    }

    return clean;
};

window.formatCnpjMasked = function (value) {
    const clean = window.cleanCnpjInput(value);

    if (!clean.length) {
        return "";
    }

    const parts = clean.split("");
    let out = parts.slice(0, 2).join("");

    if (parts.length > 2) {
        out += "." + parts.slice(2, Math.min(5, parts.length)).join("");
    }
    if (parts.length > 5) {
        out += "." + parts.slice(5, Math.min(8, parts.length)).join("");
    }
    if (parts.length > 8) {
        out += "/" + parts.slice(8, Math.min(12, parts.length)).join("");
    }
    if (parts.length > 12) {
        out += "-" + parts.slice(12, Math.min(14, parts.length)).join("");
    }

    return out;
};

window.removerMascaraCnpj = function (input) {
    $(input).off(".cnpjMask");
    $(input).unmask();
};

window.mascaraCnpj = function (input) {
    const $input = $(input);

    window.removerMascaraCnpj(input);

    const applyFormat = function () {
        const el = input;
        const cursor = el.selectionStart ?? el.value.length;
        const rawBeforeCursor = window.cleanCnpjInput(
            el.value.substring(0, cursor)
        ).length;

        el.value = window.formatCnpjMasked(el.value);

        let rawSeen = 0;
        let newCursor = el.value.length;

        for (let i = 0; i < el.value.length; i++) {
            if (/[0-9A-Z]/i.test(el.value[i])) {
                rawSeen++;
                if (rawSeen >= rawBeforeCursor) {
                    newCursor = i + 1;
                    break;
                }
            }
        }

        if (document.activeElement === el && typeof el.setSelectionRange === "function") {
            el.setSelectionRange(newCursor, newCursor);
        }
    };

    $input.on("input.cnpjMask", applyFormat);
    $input.on("blur.cnpjMask", applyFormat);

    if ($input.val()) {
        $input.val(window.formatCnpjMasked($input.val()));
    }
};

window.normalizarCpfCnpj = function (value) {
    const cnpj = window.sanitizeCnpj(value);
    if (cnpj.length > 11 || /[A-Z]/.test(cnpj.substring(0, Math.min(12, cnpj.length)))) {
        return cnpj;
    }

    return String(value || "").replace(/\D/g, "");
};
